import React from 'react';

export const Confidentialite = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Politique de confidentialité et cookies</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Introduction</h2>
            <p className="text-gray-600 leading-relaxed">
              Dans le cadre de son activité, Richard SAAD - Consultant Informatique est amené à collecter et 
              traiter des données personnelles vous concernant. Cette politique de confidentialité vous informe 
              sur les modalités de collecte et de traitement de vos données en conformité avec le Règlement 
              Général sur la Protection des Données (RGPD).
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Responsable du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le responsable du traitement des données personnelles est :<br />
              <strong>Richard SAAD</strong> - Micro-entrepreneur<br />
              SIRET : 927 968 651 00012<br />
              Email : <a href="mailto:richard@saad-informatique.fr" className="text-blue-600 hover:text-blue-700 break-all">richard@saad-informatique.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Données collectées</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Nous collectons les données personnelles suivantes via le formulaire de contact :
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone (optionnel)</li>
              <li>Nom de la société (optionnel)</li>
              <li>Informations renseignées dans le message</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Finalité du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Les données personnelles collectées via le formulaire de contact sont utilisées uniquement pour :
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mt-4">
              <li>Répondre à vos demandes d'information</li>
              <li>Vous recontacter dans le cadre de votre demande de service</li>
              <li>Établir un devis ou une proposition commerciale si demandé</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Durée de conservation</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données personnelles sont conservées pendant une durée maximale de <strong>3 ans</strong> à 
              compter de notre dernier contact. Passé ce délai, vos données seront supprimées, sauf obligation 
              légale de conservation plus longue.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Vos droits</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Droit d'accès</strong> : vous pouvez demander à consulter les données que nous détenons sur vous</li>
              <li><strong>Droit de rectification</strong> : vous pouvez demander la correction de données inexactes</li>
              <li><strong>Droit à l'effacement</strong> : vous pouvez demander la suppression de vos données</li>
              <li><strong>Droit d'opposition</strong> : vous pouvez vous opposer au traitement de vos données</li>
              <li><strong>Droit à la portabilité</strong> : vous pouvez demander à recevoir vos données dans un format structuré</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse : <a href="mailto:richard@saad-informatique.fr" className="text-blue-600 hover:text-blue-700 font-semibold break-all">richard@saad-informatique.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Sécurité des données</h2>
            <p className="text-gray-600 leading-relaxed">
              Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées afin de garantir 
              un niveau de sécurité adapté au risque, notamment contre la destruction accidentelle ou illicite, 
              la perte, l'altération, la divulgation ou l'accès non autorisé à vos données personnelles.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Cookies</h2>
            <p className="text-gray-600 leading-relaxed">
              Ce site utilise des cookies techniques nécessaires au bon fonctionnement du site. Ces cookies ne 
              nécessitent pas votre consentement.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Modifications</h2>
            <p className="text-gray-600 leading-relaxed">
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
              Toute modification sera publiée sur cette page avec une date de mise à jour.
            </p>
            <p className="text-gray-600 leading-relaxed mt-4">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
